import React from 'react';
import { Nav } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import {
  HouseDoor,
  Folder2Open,
  PeopleFill,
  PersonBadge,
  BarChartLine,
  GearFill,
} from 'react-bootstrap-icons';
import '../styles/Sidebar.css';

const Sidebar = ({ isOpen, closeSidebar }) => {
  const menuItems = [
    { path: '/', icon: HouseDoor, label: 'Dashboard' },
    { path: '/projects', icon: Folder2Open, label: 'Projects' },
    { path: '/leads', icon: PeopleFill, label: 'Leads' },
    { path: '/employees', icon: PersonBadge, label: 'Employees' },
    { path: '/settings', icon: GearFill, label: 'Settings' },
  ];

  return (
    <>
      <div className={`sidebar-overlay ${isOpen ? 'show' : ''}`} onClick={closeSidebar} />
      <div className={`sidebar ${isOpen ? 'show' : ''}`}>
        <div className="sidebar-header">
          <div className="d-flex align-items-center">
            <div className="sidebar-logo me-2">
              <BarChartLine size={24} color="white" />
            </div>
            <h5 className="mb-0 text-white fw-bold">Manager Panel</h5>
          </div>
          <button
            className="btn btn-link text-white d-lg-none p-0"
            onClick={closeSidebar}
          >
            <i className="bi bi-x-lg fs-5"></i>
          </button>
        </div>

        <div className="sidebar-user px-3 py-3">
          <div className="d-flex align-items-center">
            <div className="sidebar-user-avatar me-2">MP</div>
            <div>
              <div className="text-white small fw-semibold">Manager Panel</div>
              <div className="text-white-50" style={{ fontSize: '11px' }}>Administration</div>
            </div>
          </div>
        </div>

        <Nav className="flex-column sidebar-nav">
          <div className="sidebar-section-title">MAIN MENU</div>
          {menuItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.path === '/'}
              className={({ isActive }) =>
                `nav-link sidebar-link ${isActive ? 'active' : ''}`
              }
              onClick={closeSidebar}
            >
              <span className="sidebar-icon">
                <item.icon size={18} />
              </span>
              <span className="sidebar-label">{item.label}</span>
            </NavLink>
          ))}
        </Nav>

        <div className="sidebar-footer">
          <small className="text-white-50">v1.0.0 &copy; 2025 Manager Panel</small>
        </div>
      </div>
    </>
  );
};

export default Sidebar;